import { fieldValueToString } from "global/Visibility/ParentVisibilityGraph";
import * as OptionSet from "model/AttributeOptionSets.type";
import { bcbs_groupconfigurationsnapshot } from "model/CRM";
import * as ICustomTypes from "model/CRM.type";
import * as FAM from "model/FlexibleAttributeModel";
import { v4 as uuidv4 } from 'uuid';
import { EmitEventQueue } from "./EmitEventManager";


function convertEBenefitStatus(status: FAM.TBenefitStatusOptionSetValue) {

    switch (status.value) {
        case FAM.EBenefitStatus["In-Progress"]:
            return OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_benefitstatus["In Progress(808900000)"].value;

        case FAM.EBenefitStatus["Cancelled"]:
            return OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_benefitstatus['Cancelled(808900002)'].value;

        case FAM.EBenefitStatus['Released for Notification']:
            return OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_benefitstatus['Released for Notification(808900001)'].value;
    }

    return undefined;
}

export function emitEventForBenefitPropertyChange(
    snapshot: bcbs_groupconfigurationsnapshot,
    benefit: FAM.IBenefit | null,
    newBenefit: FAM.IBenefit,
    cloning?: boolean,
) {
    let emit = false;

    if (cloning || benefit?.status?.value !== newBenefit.status.value)
        if (
            newBenefit.status.value === FAM.EBenefitStatus["Released for Notification"] ||
            newBenefit.status.value === FAM.EBenefitStatus['Cancelled']
        )
            emit = true;

    if (emit) {
        // Queue
        const emitEvent: ICustomTypes.Ibcbs_groupconfigurationsnapshoteventUpdate = {
            // Benefit Name
            bcbs_benefitname: newBenefit.name,

            // Category Name
            bcbs_categoryname: newBenefit.bcbs_name!,

            // Type (Field Event, Benefit Event) default to Benefit Event
            bcbs_eventtypecode: OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_eventtypecode['Benefit Event(808900001)'].value,

            // Benefit Status
            bcbs_benefitstatus: convertEBenefitStatus(newBenefit.status),
        }

        if (cloning)
            emitEvent.bcbs_groupconfigurationsnapshoteventid = uuidv4();

        if (!emitEvent.bcbs_groupconfigurationsnapshoteventid)
            emitEvent.bcbs_groupconfigurationsnapshoteventid = uuidv4();

        emitEvent["bcbs_GroupConfigurationSnapshotid@odata.bind"] = `/bcbs_groupconfigurationsnapshots(${snapshot.bcbs_groupconfigurationsnapshotid})`;

        // ownerid
        // -----------------------------------
        if (snapshot._owningteam_value)
            emitEvent["ownerid@odata.bind"] = `/teams(${snapshot._owningteam_value})`;

        EmitEventQueue({ item: emitEvent });
    }

}

export function emitEventForFieldChange(
    config: FAM.IGroupConfigurationConfig,
    snapshot: bcbs_groupconfigurationsnapshot,
    benefit: FAM.IBenefit | null,
    field: FAM.IFlexibleField,
    fieldValue: FAM.IFlexibleFieldValue,
    newValue: FAM.TValue,
    cloning?: boolean,
    ignoreDelta?: boolean,
) {
    let emit = false;

    const configAttribute = config.cache.map_bcbs_config_attribute[field.configRef.id];

    let newValueStr: string | null = null;

    if (configAttribute?.bcbs_isemitevent) {

        newValueStr = fieldValueToString(config, newValue, false);

        if (ignoreDelta)
            emit = true;

        if (!emit) {
            const oldValueStr = fieldValueToString(config, fieldValue?.value, false);
            if (oldValueStr !== newValueStr)
                emit = true;
        }
    }

    if (configAttribute?.bcbs_isemiteventonclone)
        if (cloning)
            emit = true;

    if (emit) {

        let creating = false;

        // Queue
        const emitEvent: ICustomTypes.Ibcbs_groupconfigurationsnapshoteventUpdate = {
            bcbs_eventtypecode: OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_eventtypecode['Field Event(808900000)'].value
        }

        if (fieldValue.emitRefId)
            emitEvent.bcbs_groupconfigurationsnapshoteventid = fieldValue.emitRefId;

        if (cloning) {
            emitEvent.bcbs_groupconfigurationsnapshoteventid = uuidv4();
            creating = true;
        }

        if (!emitEvent.bcbs_groupconfigurationsnapshoteventid) {
            emitEvent.bcbs_groupconfigurationsnapshoteventid = uuidv4();
            creating = true;
        }

        if (benefit) {
            emitEvent.bcbs_benefitname = benefit.name;
            emitEvent.bcbs_categoryname = benefit.bcbs_name!;
            emitEvent.bcbs_benefitstatus = convertEBenefitStatus(benefit.status);
            // emitEvent.bcbs_eventtypecode = OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_eventtypecode['Benefit Event(808900001)'].value
        }

        if (snapshot?.bcbs_groupconfigurationsnapshotid)
            emitEvent["bcbs_GroupConfigurationSnapshotid@odata.bind"] = `/bcbs_groupconfigurationsnapshots(${snapshot.bcbs_groupconfigurationsnapshotid})`;

        if (configAttribute?.bcbs_config_attributeid)
            emitEvent["bcbs_Attributeid@odata.bind"] = `/bcbs_config_attributes(${configAttribute.bcbs_config_attributeid})`;

        if (configAttribute?._bcbs_config_masterattributeid_value)
            emitEvent["bcbs_MasterAttrributeid@odata.bind"] = `/bcbs_config_attributes(${configAttribute._bcbs_config_masterattributeid_value})`;

        emitEvent.bcbs_name = field.name;

        if (newValueStr) {
            emitEvent.bcbs_value = newValueStr;
        }

        emitEvent.bcbs_eventorigincode = OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_eventorigincode["Update(808900001)"].value;

        if (cloning)
            emitEvent.bcbs_eventorigincode = OptionSet.bcbs_groupconfigurationsnapshotevent.bcbs_eventorigincode['Clone from Parent(808900000)'].value;

        // ownerid
        // -----------------------------------
        if (snapshot._owningteam_value)
            emitEvent["ownerid@odata.bind"] = `/teams(${snapshot._owningteam_value})`;

        EmitEventQueue({ item: emitEvent, creating: creating });

        return emitEvent;
    }

}
